import React, { Component } from 'react';
import './RpmModalGraphHeader.css';

import { inject, observer } from 'mobx-react';

import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { download } from '../../../../../../../helpers';

import AirButton from '../../../../../../../common/components/AirButton';
import { DownloadIcon } from '../../../../../../../common/icons';

import AirDatePicker from '../../../../../../../common/components/AirDatePicker';

@inject('translationsStore', 'commonStore')
@observer
export default class RpmModalGraphHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: this.props.startDate,
      endDate: this.props.endDate
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { startDate, endDate } = prevState;
    if (this.props.startDate && !isEqual(this.props.startDate, startDate)) {
      this.setState({ startDate: this.props.startDate });
    }

    if (this.props.endDate && !isEqual(this.props.endDate, endDate)) {
      this.setState({ endDate: this.props.endDate });
    }
  };

  onChangeStartDate = startDate => {
    if (moment(startDate).isAfter(moment())) {
      return false;
    } else {
      this.props.onChange(startDate, this.state.endDate);
    }
  };

  onChangeEndDate = endDate => {
    if (moment(endDate).isAfter(moment())) {
      return false;
    } else {
      this.props.onChange(this.state.startDate, endDate);
    }
  };

  downloadRpms = () => {
    console.log('download rpms');
    const { translationsStore, commonStore } = this.props;
    const fields = [
      {
        label: translationsStore.translate('quickFocus.rpm.export.date'),
        value: row => `${moment(row.startDateTime).format(commonStore.longDateFormat.L)} ${moment(row.startDateTime).format(commonStore.longDateFormat.LT)}`
      },
      {
        label: translationsStore.translate('quickFocus.rpm.export.position'),
        value: row => row.address
      },
      {
        label: translationsStore.translate('quickFocus.rpm.export.rpmMaxValue'),
        value: row => row.value
      },
      {
        label: translationsStore.translate('quickFocus.rpm.export.duration'),
        value: row => row.duration
      },
      {
        label: translationsStore.translate('quickFocus.rpm.export.distance'),
        value: row => Math.round(row.distance)
      }
    ];

    const exportFilename = 'rpms.csv';

    download.csv({ fields: fields, rawdata: this.props.rpms.rpms || [], filename: exportFilename });
  };

  render() {
    const { translationsStore, overRpmThreshold } = this.props;
    const { startDate, endDate } = this.state;

    return (
      <React.Fragment>
        <div className="RpmModalGraphHeader">
          <div className="header">
            <div className="daterange">
              <AirDatePicker
                onChange={this.onChangeStartDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                duration
                prefix={translationsStore.translate('quickFocus.rpm.filter.date.from')}
                selected={startDate}
                dateFormat="dd MMM YYY"
              />
              <AirDatePicker
                onChange={this.onChangeEndDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                prefix={translationsStore.translate('quickFocus.rpm.filter.date.to')}
                selected={endDate}
                dateFormat="dd MMM YYY"
              />
            </div>
            {!!overRpmThreshold && <div className="OverRpmThreshold">{`${translationsStore.translate('quickFocus.rpm.filter.overRpmThreshold')}: ${overRpmThreshold}`}</div>}
            <AirButton
              bgcolor="transparent"
              color="var(--selected-color)"
              size="large"
              icon={<DownloadIcon style={{ width: '13px', height: '16px', color: 'var(--selected-color)', marginRight: '11px' }} />}
              label={translationsStore.translate('quickFocus.rpm.filter.download')}
              onClick={this.downloadRpms}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmModalGraphHeader/RpmModalGraphHeader.js